<div class="title-search-bar">
  <form autocomplete="off">
    <div class="input-group search-group mb-0 open">
      <input
        id="search-input"
        #searchInput
        type="text"
        class="form-control narrow-search open square-input"
        autocomplete="off"
        placeholder="Search People"
        (keyup)="search($event)"
        (blur)="showResults()"
        (focus)="showResults()" />
      <button class="btn btn-primary"><img src="assets/icons/search-white.svg" /></button>
      <div *ngIf="showSearchResults && hasSearched" id="results-list" class="card">
        <div class="card-body">
          <small>
            <em *ngIf="!items || items.length === 0">No results found</em>
          </small>
          <!-- if theres no client code, we are searching clients -->
          <ul *ngIf="items && clientCode">
            <li *ngFor="let item of items.slice(0, maxResultSet)">
              <a routerLink="/client/{{ clientCode }}/person/{{ item.Id }}">
                <strong>{{ displayPerson(item) }} </strong>
              </a>
            </li>
          </ul>
          <div *ngIf="items && items.length > maxResultSet">
            <br />
            <a
              *ngIf="clientCode"
              routerLink="/client/{{ clientCode }}/people/search/{{ searchQuery }}"
              class="text-muted"
              >View All Results</a
            >
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
